module.exports = __webpack_public_path__ + "static/media/capping.f732769b.svg";